export default "__VITE_ASSET__Br1N43n$__"